import { createSelector } from 'reselect';
import { getQuery } from './querySelectors';

const FALLBACK_PAGE_TITLE = 'Search results | Qantas Hotels Australia';

export const getPageTitle = createSelector(getQuery, ({ location }) =>
  location ? `Hotels in ${location} | Qantas Hotels` : FALLBACK_PAGE_TITLE,
);
